import './styles.scss';

import classNames from 'classnames';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import Button from 'src/components/Button';
import { getUserProfile } from '../../containers/UserProfile/selectors';

const translationsScope = 'components.Profile.ProfileSettings';

export interface IProfileSettingsHandlers {
  onLogout: () => void;

  onPasswordChangeClick: (event: React.SyntheticEvent<HTMLButtonElement>) => void;

  onWordsGoalChangeClick: (event: React.SyntheticEvent<HTMLButtonElement>) => void;
}

const ProfileSettings: React.FunctionComponent<IProfileSettingsHandlers> = ({
  onLogout,
  onPasswordChangeClick,
  onWordsGoalChangeClick,
}) => {
  const {
    userInfo,
    settings: { wordsGoal },
  } = useSelector(getUserProfile);

  const email = userInfo ? userInfo.email : '';

  const cn = classNames('ProfileSettings');

  return (
    <div className={cn}>
      <div className="ProfileSettings-title">
        <FormattedMessage id={`${translationsScope}.title`} />
      </div>
      <div className="ProfileSettings-content">
        <div className="ProfileSettings-row">
          <div className="ProfileSettings-column">
            <div className="ProfileSettings-label">
              <FormattedMessage id={`${translationsScope}.email`} />
            </div>
            <div className="ProfileSettings-value">{email}</div>
          </div>
          <div className="ProfileSettings-column">
            <div className="ProfileSettings-button">
              <Button color="orange" outline={true} block={true} onClick={onLogout}>
                <FormattedMessage id={`${translationsScope}.logout`} />
              </Button>
            </div>
          </div>
        </div>
        <div className="ProfileSettings-row">
          <div className="ProfileSettings-column">
            <div className="ProfileSettings-label">
              <FormattedMessage id={`${translationsScope}.password`} />
            </div>
            <div className="ProfileSettings-value">**********</div>
          </div>
          <div className="ProfileSettings-column">
            <div className="ProfileSettings-button">
              <Button color="grey" outline={true} block={true} onClick={onPasswordChangeClick}>
                <FormattedMessage id={`${translationsScope}.change`} />
              </Button>
            </div>
          </div>
        </div>
        <div className="ProfileSettings-row">
          <div className="ProfileSettings-column">
            <div className="ProfileSettings-label">
              <FormattedMessage id={`${translationsScope}.wordsGoal`} />
            </div>
            <div className="ProfileSettings-value">{wordsGoal}</div>
          </div>
          <div className="ProfileSettings-column">
            <div className="ProfileSettings-button">
              <Button color="grey" outline={true} block={true} onClick={onWordsGoalChangeClick}>
                <FormattedMessage id={`${translationsScope}.change`} />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo<IProfileSettingsHandlers>(ProfileSettings);



// WEBPACK FOOTER //
// ./src/components/ProfileSettings/index.tsx